import { type FormEvent, useState } from "react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

import type { HandleGetHelpFunction } from "./AiHelpCard";

export interface AiHelpAskProps {
  onAskQuestion: HandleGetHelpFunction;
}

export function AiHelpAsk({ onAskQuestion }: Readonly<AiHelpAskProps>) {
  const [question, setQuestion] = useState("");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (question.trim()) {
      onAskQuestion({ question, context: "" });
      setQuestion("");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col space-y-2">
      <div className="flex space-x-2">
        <Input
          type="text"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          placeholder="Type your question here..."
          className="flex-grow"
        />
        <Button type="submit" disabled={!question.trim()}>
          Ask
        </Button>
      </div>
    </form>
  );
}
